import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

// Persist session in localStorage so users stay signed in after closing the browser
// until they explicitly sign out. autoRefreshToken keeps the session valid.
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    storage: typeof window !== 'undefined' ? window.localStorage : undefined,
    storageKey: 'sb-auth-token',  // Consistent storage key
    autoRefreshToken: true,
    detectSessionInUrl: true,
    // Refresh token 5 minutes before expiry to prevent session loss
    refreshRateLimiter: {
      delayInSeconds: 0,
    },
  },
})

// Helper function to get current session
export async function getCurrentSession() {
  const { data: { session }, error } = await supabase.auth.getSession()
  if (error) {
    console.error('Error getting session:', error)
    return null
  }
  return session
}

// Helper function to get current user
export async function getCurrentUser() {
  const { data: { user }, error } = await supabase.auth.getUser()
  if (error) {
    console.error('Error getting user:', error)
    return null
  }
  return user
}

// Helper to get auth token for API calls
export async function getAuthToken() {
  const session = await getCurrentSession()
  return session?.access_token || null
}
